import SliderCarouselItem from './sliderCarouselItem/sliderCarouselItem.component';
import Pagination from './pagination/pagination.component';

export { Pagination, SliderCarouselItem };
